import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz39 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel40'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel38'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article
    class="container">
    <h1 class="title">100 coins puzzle</h1>
   
    <div class="text">
        <p>
                    &nbsp;&nbsp;<br/>
                    <strong>Question</strong>: 100 coins are lying flat on
            a table. 10 of them are heads up and 90 are tails up.You can’t see which one is which.How can we split the
            coins into two piles such that there are same number of heads up in each pile?</p>
        <p><strong>Note: </strong>It is allowed to flip the coins of one pile
            once.<br/>
            &nbsp;&nbsp;<br/>
            </p>
            <div className='containers'>
            <p><strong>Answer</strong>: Make 2 piles with 10 coins and 90 coins each. Now, flip
            all the coins in the smaller pile.&nbsp;<br/>
            &nbsp;&nbsp;<br/>
            <strong>Explanation </strong>:&nbsp;Make&nbsp;2
            piles and say pile one has ‘h’ no. of heads and ‘t’ no. of tails while the other pile will have ’10-h’ heads
            and ’90-t’ tails.Now we can flip coins of one pile,so lets flip coins of any pile(say 2nd pile) then no. of
            heads and tails interchange and now no. of heads are ’90-t’ and no. of tails are ’10-h’.</p></div>
        <p>Now no. of heads in pile 1 = no. of heads in pile 2</p>
        <p>h=90-t</p>
        <p>Therefore,h+t=90</p>
        <p>And no. of coins in pile 1 is ‘h+t’</p>
        <p>So,split the coins into 90 and 10.<br/>
            &nbsp;&nbsp;<br/>

        </p>
    </div>
</article>
        </div>
    )
}

export default Puz39
